/**
 * ExecutiveSummary Functional Component
 * @Package - seo
 * @Author - manila
 * @description: Seo executive summary - topfold
 */
import React, {
  useMemo,
  useContext,
  useRef,
  useEffect,
  useState,
} from 'react'
import {
  Box,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
} from '@usap/uicomponents'
import { LocalContext } from '../../../helpers/useLocalContext'

import {
  Container,
  SummaryTitle,
  Content,
  ToggleArrow,
  ToggleText,
  ToggleInput,
} from './styled.css'

import useIsTruncated from './isTruncated.hook'

export default function ExecutiveSummary({ dynamicApiData }) {
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext
  const contentElement = useRef(null)
  const isTruncated = useIsTruncated(contentElement)
  const [showToggle, setShowToggle] = useState(false)

  const id = 'ExecutiveSummary'

  const summary = useMemo(() => dynamicApiData && dynamicApiData.summary, [dynamicApiData])

  const summaryData = useMemo(() => (summary && summary.data) || '', [summary])
  const summaryDataIsNull = useMemo(() => !summaryData || summaryData === '', [summaryData])

  const hasHeroshotBanner = useMemo(() => dynamicApiData && dynamicApiData.heroshot,
    [dynamicApiData])

  const headings = useMemo(() => dynamicApiData && dynamicApiData.headings, [dynamicApiData])
  const title = useMemo(() => (headings && headings.summary) || '', [headings])
  const titleIsNull = useMemo(() => Boolean(title === ''), [title])

  const summaryHtml = useMemo(() => ({
    __html: summaryData,
  }), [summaryData])

  useEffect(() => {
    if (isTruncated && !isBot) {
      setShowToggle(true)
    }
  }, [isBot, isTruncated])

  if (summaryDataIsNull && titleIsNull) {
    return null
  }

  return (
    <Container
      id="ExecutiveSummary"
      width="1248px"
      wrap="true"
      direction="row"
    >
      {
        !hasHeroshotBanner && (
          <Box width="100%">
            <SummaryTitle label={title} type="h1" />
          </Box>
        )
      }
      {summary && !summaryDataIsNull && (
        <Box id={`${id}Content`}>
          <ToggleInput
            type="checkbox"
            id={`${id}ContentTextExpand`}
            contentKey={`${id}ContentText`}
            autoComplete="off"
          />
          <Content
            id={`${id}ContentText`}
            ref={contentElement}
            dangerouslySetInnerHTML={summaryHtml}
          />
          <Box
            id={`${id}toggleBox`}
            direction="row"
            justify="left"
            align="left"
            height="24px"
          >
            {showToggle && (
              <ToggleText
                for={`${id}ContentTextExpand`}
                size="16px"
                color="blueLink"
              >
                {isTruncated ? 'Show More' : 'Show Less'}

                <ToggleArrow
                  icon={isTruncated ? KeyboardArrowDownIcon : KeyboardArrowUpIcon}
                  color="blueLink"
                  size="20px"
                />
              </ToggleText>
            )}
          </Box>
        </Box>
      )}
    </Container>
  )
}
